import { DisposalSet } from '@neptune/cx/utils';
import { registerFragment } from '@neptune/cx/registry';
import './styles.scss';

const gc = new DisposalSet();

registerFragment('ay-service-card-list', (fragEl, config, meta) => { });

if (import.meta.hot) {
    import.meta.hot.accept();
    import.meta.hot.dispose(() => gc.disposeAll());
}
